<template>
  <a-modal v-model="visible" title="系列视频标签" @ok="handleOK">
    <a-form
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
      labelAlign="left"
    >
      <a-form-item label="大类" class="link-material-form-item">
        <a-select v-model="type">
          <a-select-option :value="1">公司</a-select-option>
          <a-select-option :value="2">产品</a-select-option>
          <a-select-option :value="0">素材</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="素材关联"
        class="link-material-form-item"
        v-if="linkType === 'material'"
      >
        <a-select placeholder="选择一个关联素材。" v-model="linkValue">
          <a-select-option
            v-for="mat in linkableMaterials"
            :key="mat.id"
            :value="mat.id"
          >
            {{ mat.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="分类与标签"
        class="link-material-form-item"
        v-if="linkType !== 'material' || linkValue"
      >
        <a-select placeholder="选择一个标签。" v-model="value">
          <a-select-option
            v-for="op in tagData"
            :key="op.material_label_id"
            :value="op.material_label_id"
          >
            {{ op.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="产品关联"
        class="link-material-form-item"
        v-if="linkType === 'product'"
        extra="请输入一个位于 1 和 7 之间的数字。"
      >
        <a-input-group>
          <a-input-number
            v-model="linkValue"
            :min="0"
            :max="6"
            class="setting-input"
            :formatter="displayValue"
            :parser="parseValue"
          />
        </a-input-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue';
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      value: undefined,
      type: 1,
      linkValue: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedEffect', 'activeFragment']),
    ...mapState(['effects', 'videoSeriesTagData']),
    visible: {
      get() {
        return this.$store.state.textVideoSeriesTagVisible;
      },
      set(value) {
        this.$store.commit('handleTextVideoSeriesTagVisible', value);
      }
    },
    linkType() {
      if (this.type === 0) {
        return 'material';
      }
      if (this.value) {
        let item;
        if (
          this.tagData.some(t => {
            if (t.material_label_id === this.value) {
              item = t;
              return true;
            }
            return false;
          })
        ) {
          return [null, 'product', 'material'][item.isDefault];
        }
      }

      return null;
    },
    linkedEffect() {
      if (this.type === 0 && this.linkValue) {
        return this.$store.state.effects[this.linkValue] || null;
      }
      return null;
    },
    tagData() {
      if (this.type !== 0) {
        const ret = this.videoSeriesTagData[this.type];
        if (ret.common_text) {
          return Object.keys(ret.common_text).map(k => ret.common_text[k]);
        }
        return [];
      }

      const effect = this.linkedEffect;
      const effectTags = effect && effect.videoSeriesTags;

      if (effectTags) {
        const tag = effectTags.slice(1).reduce((prev, cur) => {
          let ret = null;
          (prev.lower || prev.text).some(x => {
            if (x.material_label_id === cur) {
              ret = x;
              return true;
            }
            return false;
          });
          return ret;
        }, this.videoSeriesTagData[effectTags[0]]);
        if (tag) {
          return tag.text;
        }
      }

      return [];
    },
    values() {
      if (!this.value) {
        return [];
      }
      if (this.type === 0) {
        const effect = this.linkedEffect;

        if (effect && effect.videoSeriesTags) {
          return effect.videoSeriesTags.slice(1).concat(this.value);
        }
        return [];
      }
      return [this.value];
    },
    linkableMaterials() {
      const ret = [];
      if (this.linkType === 'material') {
        const pushEffect = (effect, name = effect.content.name) => {
          if (effect.videoSeriesTags) {
            ret.push({ id: effect.id, name });
          }
        };
        this.activeFragment.effects.forEach(id => {
          if (id === this.selectedEffect.id) {
            return;
          }
          const effect = this.effects[id];

          switch (effect.type) {
            case 'image':
            case 'video':
              pushEffect(effect);
              break;
            case 'group':
            case 'container':
            case 'textContainer': {
              const prevName = effect.content.name || (effect.type === 'textContainer' && effect.content.text) || 'container or group';
              effect.children.forEach(cid => {
                if (cid === this.selectedEffect.id) {
                  return;
                }
                const childEffect = this.effects[cid];
                if (childEffect.type === 'image' || childEffect.type === 'video') {
                  pushEffect(childEffect, [prevName, childEffect.content.name].join('/'));
                }
              });
            }
          }
        });
      }
      return ret;
    }
  },
  methods: {
    handleOK() {
      if (this.linkType === 'material' && this.linkValue === undefined) {
        message.error('请选择一个关联素材。');
        return;
      }
      if (!this.value) {
        message.error('请选择系列视频标签。');
        return;
      }
      if (this.linkType) {
        if (this.linkValue === undefined) {
          message.error('请选择一个关联产品。');
          return;
        }
        this.$set(this.selectedEffect, 'videoSeriesTagParams', {
          type: this.linkType,
          link: this.linkValue
        });
      } else {
        this.$set(this.selectedEffect, 'videoSeriesTagParams', null);
      }
      this.$set(
        this.selectedEffect,
        'videoSeriesTags',
        [this.type].concat(this.values) // TODO: type may be 0 when linked to material (see PreviewStep.vue)
      );
      message.info('标签编辑成功。');
      this.visible = false;
    },
    displayValue(v) {
      if (typeof v === 'undefined' || v === '') {
        return '';
      }
      return +v + 1;
    },
    parseValue(v) {
      if (typeof v === 'undefined' || v === '') {
        return '';
      }

      return v - 1;
    }
  },
  watch: {
    type() {
      this.value = undefined;
    },
    linkType() {
      this.linkValue = this.linkType === 'product' ? 0 : undefined;
    },
    visible(val) {
      if (val && this.selectedEffect) {
        const { videoSeriesTags, videoSeriesTagParams } = this.selectedEffect;
        if (videoSeriesTags) {
          this.type = (videoSeriesTagParams && videoSeriesTagParams.type === 'material') ? 0 : videoSeriesTags[0];
          this.$nextTick(() => {
            this.value = videoSeriesTags[videoSeriesTags.length - 1];
            this.$nextTick(() => { // after execution of the watchers
              if (videoSeriesTagParams) {
                this.linkValue = videoSeriesTagParams.link;
              }
            });
          });
        } else {
          this.type = 1;
          this.value = undefined;
        }
      }
    }
  }
}
</script>